import {authRequest} from './api/auth';

class KnowledgeLibraryService {
    list() {
        // return authRequest.get(`/chatgpt/upgpt/knowledge_library/`);
        return authRequest.get(`/upgpt/v2/knowledge/knowledgelibrary/`);
    }
    portal_list() {
        return authRequest.get(`/upgpt/v2/knowledge/knowledgelibraryforportal/`);
    }
    select_list(){
        // return authRequest.get(`/chatgpt/upgpt/knowledge_selectlist/`);
        return authRequest.get(`/upgpt/v2/knowledge/knowledgeselectlist/`);
    }

    create(data, is_private=false) {
        // return authRequest.post(`/chatgpt/upgpt/knowledge_library/`,data);
        if (is_private) {
            return authRequest.post(`/upgpt/v2/knowledge/privateknowledgelibrary/`, data);
        } else {
            return authRequest.post(`/upgpt/v2/knowledge/knowledgelibrary/`,data);
        }

    }
    select_files(data) {
        return authRequest.post(`/upgpt/v2/knowledge/knowledgefiles/`, data);
    }
    list_private(little) {
        if (little) {
            return authRequest.get(`/upgpt/v2/knowledge/privateknowledgelibrary/?fields=little`);
        } else {
            return authRequest.get(`/upgpt/v2/knowledge/privateknowledgelibrary/`);
        }
    }
    detail(id,is_private=false) {
        // return authRequest.get(`/chatgpt/upgpt/knowledge_library_change/${id}/`);
        if (is_private) {
            return authRequest.get(`/upgpt/v2/knowledge/privateknowledgelibrarychange/${id}/`);
        }
        else {
            return authRequest.get(`/upgpt/v2/knowledge/knowledgelibrarychange/${id}/`);
        }
    }
    set_detail_bots(data){
        // return authRequest.put(`/chatgpt/upgpt/knowledge_lib_linked_bot_change/${data.id}/`,data);
        return authRequest.put(`/upgpt/v2/knowledge/knowledgeliblinkedbotchange/${data.id}/`,data);
    }
    edit(data,is_private=false){
        // return authRequest.put(`/chatgpt/upgpt/knowledge_library_change/${data.id}/`,data);
        if (is_private) {
            return authRequest.put(`/upgpt/v2/knowledge/privateknowledgelibrarychange/${data.id}/`,data);
        }
        else {
            return authRequest.put(`/upgpt/v2/knowledge/knowledgelibrarychange/${data.id}/`, data);
        }
    }
    delete(id,is_private=false){
        // return authRequest.delete(`/chatgpt/upgpt/knowledge_library_change/${id}/`);
        if (is_private) {
            return authRequest.delete(`/upgpt/v2/knowledge/privateknowledgelibrarychange/${id}/`);
        }
        else {
            return authRequest.delete(`/upgpt/v2/knowledge/knowledgelibrarychange/${id}/`);
        }
    }
    clear_knowledge(id){
        // return authRequest.post(`/chatgpt/upgpt/clear_knowledge/${id}/`);
        return authRequest.post(`/upgpt/v2/knowledge/clearknowledge/${id}/`);
    }
    getknowledgedetail(id){
        // return authRequest.post(`/chatgpt/upgpt/getknowledgedetail/${id}/`);
        return authRequest.post(`/upgpt/v2/knowledge/getknowledgedetail/${id}/`);
    }
    getknowledgecategoryoption(){
        return authRequest.post(`/upgpt/v2/knowledge/getknowledgecategoryoption/`);
    }
    uploadqafilebyacs(data,file){
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        let formData = new FormData();
        formData.append('file', file);
        formData.append('knowledge_lib_id', data.knowledge_lib_id);
        formData.append('name', data.name);
        formData.append('describe_image_by_ai', data.describe_image_by_ai);
        formData.append('save_customeized_attributes', data.save_customeized_attributes);
        formData.append('image_search', data.image_search);
        formData.append('upgpt_table_configuration_id', data.upgpt_table_configuration_id);
        formData.append('intelligent_document_analysis', data.intelligent_document_analysis);
        // return authRequest.post(`/chatgpt/upgpt/uploadqafilebyacs/`,formData,config);
        return authRequest.post(`/upgpt/v2/upload/uploadqafilebyacs/`,formData,config);
    }
    uploadFolder(data,file){
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        let formData = new FormData();
        formData.append('file', file);
        formData.append('knowledge_lib_id', data.knowledge_lib_id);
        formData.append('name', data.name);
        formData.append('describe_image_by_ai', data.describe_image_by_ai);
        formData.append('save_customeized_attributes', data.save_customeized_attributes);
        formData.append('image_search', data.image_search);
        formData.append('upgpt_table_configuration_id', data.upgpt_table_configuration_id);
        formData.append('intelligent_document_analysis', data.intelligent_document_analysis);
        // return authRequest.post(`/chatgpt/upgpt/uploadfolderbyacs/`,formData,config);
        return authRequest.post(`/upgpt/v2/upload/uploadfolderbyacs/`,formData,config);
    }
    uploadFile(data,file){
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        let formData = new FormData();
        formData.append('file', file);
        formData.append('knowledge_lib_id', data.knowledge_lib_id);
        formData.append('name', data.name);
        formData.append('describe_image_by_ai', data.describe_image_by_ai);
        formData.append('save_customeized_attributes', data.save_customeized_attributes);
        formData.append('image_search', data.image_search);
        formData.append('upgpt_table_configuration_id', data.upgpt_table_configuration_id);
        formData.append('intelligent_document_analysis', data.intelligent_document_analysis);
        // return authRequest.post(`/chatgpt/upgpt/uploadfilebyacs/`,formData,config);
        return authRequest.post(`/upgpt/v2/upload/uploadfilebyacs/`,formData,config);
    }
    uploadImg(data,file){
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        let formData = new FormData();
        formData.append('file', file);
        formData.append('knowledge_lib_id', data.knowledge_lib_id);
        formData.append('name', data.name);
        formData.append('describe_image_by_ai', data.describe_image_by_ai);
        formData.append('save_customeized_attributes', data.save_customeized_attributes);
        formData.append('image_search', data.image_search);
        formData.append('upgpt_table_configuration_id', data.upgpt_table_configuration_id);
        // return authRequest.post(`/chatgpt/upgpt/uploadimg/`,formData,config);
        return authRequest.post(`/upgpt/v2/upload/uploadimg/`,formData,config);
    }
    // uploadImageTest(data,file){
    //     let config = {
    //         headers: {
    //             'Content-Type': 'multipart/form-data'
    //         }
    //     }
    //     let formData = new FormData();
    //     formData.append('file', file);
    //     formData.append('knowledge_lib_id', data.knowledge_lib_id);
    //     formData.append('name', data.name);
    //     formData.append('describe_image_by_ai', data.describe_image_by_ai);
    //     formData.append('save_customeized_attributes', data.save_customeized_attributes);
    //     formData.append('image_search', data.image_search);
    //     formData.append('upgpt_table_configuration_id', data.upgpt_table_configuration_id);
    //     return authRequest.post(`/chatgpt/upgpt/uploadimg`,formData,config)
    // }
    websiteanalysis(data){
        // return authRequest.post(`/chatgpt/upgpt/webanalysisbyacs`,data);
        return authRequest.post(`/upgpt/v2/web/webanalysisbyacs/`,data);
    }
    getWebList(id){
        // return authRequest.get(`/chatgpt/upgpt/setweburl/?knowledge_lib_id=${id}`);
        return authRequest.get(`/upgpt/v2/web/setweburl/?knowledge_lib_id=${id}`);
    }
    addWebList(data){
        // return authRequest.post(`/chatgpt/upgpt/setweburl/`,data);
        return authRequest.post(`/upgpt/v2/web/setweburl/`,data);
    }
    editWebList(id,data){
        // return authRequest.put(`/chatgpt/upgpt/changeweburl/${id}`,data);
        return authRequest.put(`/upgpt/v2/web/changeweburl/${id}/`,data);
    }
    deleteWebList(id){
        // return authRequest.delete(`/chatgpt/upgpt/changeweburl/${id}`);
        return authRequest.delete(`/upgpt/v2/web/changeweburl/${id}/`);
    }
    delete_single_knowledge(id){
        // return authRequest.delete(`/chatgpt/upgpt/delete_single_knowledge/${id}`);
        return authRequest.delete(`/upgpt/v2/knowledge/deletesingleknowledge/${id}`);
    }
    downloadtxt(filename) {
        // return authRequest.post(`/chatgpt/upgpt/downloadtxt/`,filename);
        return authRequest.post(`/upgpt/v2/web/downloadtxt/`,filename);
    }
    imagecheckboxSet(id){
        // return authRequest.post(`/chatgpt/upgpt/knowledge_library/get_upload_img_setting/${id}/`);
        return authRequest.post(`/upgpt/v2/upload/getuploadimgsetting/${id}/`);
    }
    saveImagecheckboxSet(data){
        // return authRequest.post(`/chatgpt/upgpt/knowledge_library/set_upload_img_setting/`,data);
        return authRequest.post(`/upgpt/v2/upload/setuploadimgsetting/`,data);
    }
    webAnalysisSyncCheckboxChange(data){
        return authRequest.post(`/upgpt/v2/web/setsynchronizesetting/`,data);
    }
    getWebAnalysisSynchronizSetting(id){
        return authRequest.post(`/upgpt/v2/web/getsynchronizesetting/${id}/`);
    }
    getKBPermissions(data){
        return authRequest.post(`/upgpt/v2/knowledge/getpermissionsinstance/`,data);
    }
    changeKBPermissions(data){
        return authRequest.post(`/upgpt/v2/knowledge/changepermissionsinstance/`,data);
    }
    // Knowledge Folder
    createFolder(data) {
        return authRequest.post(`/upgpt/v2/knowledge/knowledgefolders/folders/`, data);
    }
    getFolderTree() {
        return authRequest.get(`/upgpt/v2/knowledge/knowledgefolders/folders/`);
    }
    getFolderPermission(data) {
        return authRequest.post(`/upgpt/v2/knowledge/knowledgefolders/getfolderpermissionsinstance/`, data);
    }
    updateFolder(folderId, data) {
        return authRequest.put(`/upgpt/v2/knowledge/knowledgefolders/folders/${folderId}`, data);
    }
    deleteFolder(folderId, data) {
        return authRequest.delete(`/upgpt/v2/knowledge/knowledgefolders/folders/${folderId}`, data);
    }
    getFolderParent(id){
        return authRequest.get(`/upgpt/v2/knowledge/knowledgefolders/foldersParent/${id}/`);
    }
    moveLibrary(libId, parentFolder, applyFolderPermission = false){
        return authRequest.put(`/upgpt/v2/knowledge/knowledgefolders/move_library/${libId}/`, {
            parent_folder: parentFolder,
            apply_folder_permission: applyFolderPermission,
        });
    }   
    // changeFolderPermission(paramsOrData) {
    //     return authRequest.post(`/upgpt/v2/knowledge/knowledgefolders/getfolderpermissionsinstance/`, { params: paramsOrData });
    // }

    // Favorite
    addFavorite(knowledge_lib_id) {
        return authRequest.post(`/upgpt/v2/knowledge/favorite/`, { knowledge_lib_id });
    }
    removeFavorite(knowledge_lib_id) {
        return authRequest.delete(`/upgpt/v2/knowledge/favorite/`, { data: { knowledge_lib_id } });
    }
}
export default new KnowledgeLibraryService();